<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="App_ads" :submit="submit"
    :status="status" :breadcrumbs="[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/app_ads'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col>

              <ValidationProvider ref="message" rules="required|max:300" v-slot="{ errors }">
                <div class="label-base pb-1">Mensaje</div>
                <v-textarea :error-messages="errors" v-model="data.message" maxlength="300" solo
                  placeholder="Descripción" hide-details="auto" class="text-tarea-base" counter="300"
                  :rules="[v => v.length <= 300 || 'Máximo 300 caracteres']" rows="8" />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <div class="label-base pb-1">Ocultar</div>
              <ValidationProvider ref="hidden" rules="" v-slot="{ errors }">
                <v-switch v-model="data.hidden" color="primary" class="input-check-base mt-0" hide-details="auto"
                  on-icon="$checkedIcon" off-icon="$unCheckedIcon"></v-switch>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "App_ads",
      title: "Anuncios App",
      data: {
        message: "",
        hidden: false,
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.App_ads.status,
    }),
  },
  watch: {},
  methods: {},
};
</script>
